export const SystemTier1DefaultTroubleshooting = () =>
    <div className="font-normal text-sm p-3 bg-error-300 rounded">
        <h4 className="font-semibold">
            For efficient resolution of any system issues, please follow these steps:
        </h4>
        <ul className="mt-4 list-decimal pl-5">
            <li>
                <span className="font-semibold">Determine</span> your connection
                type: <span className="font-semibold">Wi-Fi,
                    Ethernet,</span> or <span className="font-semibold">Cellular</span>.
            </li>
            <li>
                For Wi-Fi: <span className="font-semibold">Verify</span> if any changes were made to
                your <span className="font-semibold">ISP, network
                    password,</span> or <span className="font-semibold">network name</span>.
            </li>
            <li>
                For Ethernet: <span className="font-semibold">Reconnect</span> the ethernet cable to restore
                communication.
            </li>
            <li>
                For Cellular: <span className="font-semibold">Locate</span> the Multi-Tech
                modem, <span className="font-semibold">unplug</span> the USB
                cable, <span className="font-semibold">power off and on</span> the Gateway, ensure the modem antenna
                is vertical, and then <span className="font-semibold">reconnect</span> the USB.
            </li>
        </ul>
    </div>
